import { Injectable } from '@angular/core';
import { TriggerData } from '../../components/scheduler/models/trigger-data.model';
import { AppInstanceSchedule, ScheduleTemplate } from '../../models/appcloud/schedule.model';
import { ScheduleData } from '../../models/appcloud/scheduler.model';

@Injectable({ providedIn: 'root' })
export class ScheduleUtilsService {
    convertToFrequency(scheduleData: ScheduleData): string {
        if (!scheduleData.intervalPeriod || !scheduleData.intervalUnit) {
            return '';
        } else {
            if (scheduleData.intervalPeriod === 24) {
                return '1 day';
            } else {
                let frequency: string = scheduleData.intervalPeriod + ' ' + scheduleData.intervalUnit;
                if (scheduleData.intervalPeriod > 1) {
                    frequency += 's';
                }
                return frequency;
            }
        }
    }

    convertToDisplayTime(time: string): string {
        if (!time) {
            return '';
        } else {
            const timeParts = time.split(':');
            let hours: number = parseInt(timeParts[0], 10);
            let minutes: string;
            if (time.includes('+')) {
                minutes = timeParts[1].split('+')[0];
            } else {
                minutes = timeParts[1].split('-')[0];
            }
            if (hours > 12) {
                hours -= 12;
                return hours.toString() + ':' + minutes + ' PM';
            } else {
                if (hours === 0) {
                    return '12:' + minutes + ' AM';
                } else {
                    return hours.toString() + ':' + minutes + ' AM';
                }
            }
        }
    }

    extractOffset(time: string): string {
        if (!time) {
            return '';
        } else {
            const splitTime = time.split(':');
            const offsetHour = splitTime[1].substr(2);
            return offsetHour + ':00';
        }
    }

    generateAppInstanceSchedule(
        appinstanceId: number,
        type: string,
        jobGroup: string,
        scheduleData?: ScheduleData,
        triggerData?: TriggerData
    ): AppInstanceSchedule {
        const schedule: AppInstanceSchedule = new AppInstanceSchedule();
        schedule.appinstanceId = appinstanceId;
        schedule.jobGroup = jobGroup;
        schedule.scheduleTemplate = this.generateScheduleTemplate(type, scheduleData);
        schedule.triggerData = triggerData;
        return schedule;
    }

    private generateScheduleTemplate(type: string, scheduleData?: ScheduleData): ScheduleTemplate {
        const template = new ScheduleTemplate();
        template.scheduleType = type;
        if (scheduleData) {
            template.intervalPeriod = scheduleData.intervalPeriod;
            template.intervalUnit = scheduleData.intervalUnit;
            template.daysOfTheWeek = this.daysOfWeekLowercase(scheduleData.daysOfTheWeek);
            template.startTime = scheduleData.startTime;
            template.endTime = scheduleData.endTime;
        }
        return template;
    }

    private daysOfWeekLowercase(days: string[]): string[] {
        const daysLowercase: string[] = [];
        days.forEach(day => {
            daysLowercase.push(day.toLowerCase());
        });
        return daysLowercase;
    }
}
